import React from 'react';
import pluralize from 'pluralize';
import { Box, Text, Flex } from '@front/gatsby-ui';

import createMarkup from '@front/utils/create-markup';
import { getSizedAvatarUrl } from '@front/gatsby-utils/getSizedAvatarUrl';

import Rating from 'Components/rating';

import writerAvatar from 'Img/writer-avatar.svg';

/**
 * @type {SingleTestimonial}
 */
const TestimonialCard = ({
  order: { title, rating_writer, rating_writer_comment, rating_dt_timeago },
  writer: { pen_name, avatar, orders_finished_qty },
}) => (
  <Box
    mr={{
      sm: 4,
    }}
    p={3}
    bg="#fff"
    color="basic.5"
  >
    <Flex justifyContent="space-between">
      <Rating
        mb={3}
        rating={rating_writer}
      />
      <Text
        textAlign="end"
        fontSize={0}
        color="#333"
        mb={1}
      >
        {rating_dt_timeago}
      </Text>
    </Flex>
    <Text
      overflow="hidden"
      sx={{
        fontWeight: 'bold',
        textOverflow: 'ellipsis',
        wordBreak: 'break-word',
      }}
    >
      {title}
    </Text>

    <Text
      color="basic.4"
      mb="24px"
      dangerouslySetInnerHTML={createMarkup(rating_writer_comment)}
    />

    <Flex
      pt="24px"
      alignItems="center"
      sx={{
        borderTop: '1px solid #F0F0F0',
      }}
    >
      <Box
        sx={{
          borderRadius: '50%',
        }}
        flexShrink={0}
        mr={3}
      >
        <img
          src={avatar ? getSizedAvatarUrl(avatar) : writerAvatar}
          alt={pen_name}
          title={pen_name}
          width="56px"
          height="56px"
          loading="lazy"
        />
      </Box>

      <Box>
        <Text fontSize={0}>{pen_name}</Text>
        <Text
          fontSize={0}
          color="basic.3"
        >
          {`${orders_finished_qty} finished ${pluralize('order', Number(orders_finished_qty))}`}
        </Text>
      </Box>
    </Flex>
  </Box>
);

export default TestimonialCard;
